import { Component, ViewChild } from '@angular/core';
import { OwlOptions, CarouselComponent } from 'ngx-owl-carousel-o';
import { options2 } from '../constant';

@Component({
  selector: 'app-brands',
  templateUrl: './brands.component.html',
  styleUrls: ['./brands.component.scss'],
})
export class BrandsComponent {
  @ViewChild('owl', { static: false }) owl?: CarouselComponent;

  public slidesStore!: any[];
  public customOptions2: OwlOptions = {
    ...options2,
    autoplay: true,
    autoplayHoverPause: true, // ✅ stops when hover (if supported by your version)
  };

  ngOnInit(): void {
    this.slidesStore = [
      {
        id: 1,
        src: 'assets/img/wisotech_dunkel.png',
        alt: 'wisotech GmbH',
        title: 'wisotech GmbH',
        url: 'https://www.wisotech.de',
      },
      {
        id: 3,
        src: 'assets/img/logo_cpit_comparit-1.svg',
        alt: 'Comparit GmbH',
        title: 'Comparit GmbH',
        url: 'https://www.comparit.de',
      },
      {
        id: 4,
        src: 'assets/img/grandcapitaladvisors.svg',
        alt: 'Grand Capital Advisors',
        title: 'Grand Capital Advisors',
        url: 'https://www.grandcapadvisors.com/',
      },
      // { id: 5, src: 'assets/img/logoWhite.svg', alt: 'TrioXk', title: 'TrioXk', url: 'https://trioxk.com/' },
      {
        id: 5,
        src: 'assets/img/trioxk-t.png',
        alt: 'TrioXk',
        title: 'TrioXk',
        url: 'https://www.trioxk.com/',
      },
    ];
  }

  pauseCarousel(): void {
    // ✅ hard stop even if autoplayHoverPause is not working in your version
    this.owl?.to('stop');
  }

  playCarousel(): void {
    this.owl?.to('play');
  }
}
